module.exports = __webpack_public_path__ + "assets/img/ma-logo-20d74423.png";